import React from "react";

const ArkivetLogo = ({ color = "#fff", size = "5rem", className }) => {
    return (
        <a
            href="https://arkivet.no/"
            className={`arkivet-logo-link ${className}`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 153.231 77.914"
                fill={color}
                height={size}
            >
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M116.154,24.761H65.943V20h50.211ZM65.943,34.284H15.731V29.523H65.943Zm100.423,0H116.154V29.523h50.211ZM23.09,91.421H19.627l1.731-5.627Zm-3.9-9.09L14,97.914h3.463l1.3-3.463h5.194l1.3,3.463h3.463L23.523,82.331Zm30.3,5.194c0,1.3-.866,1.731-2.6,1.731H44.3v-3.9h2.6c1.731,0,2.6.866,2.6,2.164m3.463-.433c0-3.03-2.164-4.761-5.627-4.761H40.837V97.914H44.3V92.287h2.164l3.463,5.627h3.9l-3.9-6.06c2.164-.433,3.03-2.164,3.03-4.761m26.837-4.761H75.033l-5.194,6.06v-6.06h-3.9V97.914h3.9V92.72l1.3-1.3L75.9,97.914h4.329l-6.493-8.657Zm12.12,15.583h3.463V82.331H91.914Zm25.971-15.583-3.463,10.821-3.9-10.821h-3.9l5.627,15.583h3.9l5.627-15.583ZM136.5,91.854h6.493v-3.03H136.5V85.361h7.359v-3.03H133.035V97.914h10.821v-3.03H136.5Zm17.747-9.523v3.03h4.761V97.914h3.463V85.361h4.761v-3.03Z"
                    transform="translate(-14 -20)"
                />
            </svg>
        </a>
    );
};

export default ArkivetLogo;
